<template>
    <div class="row pt-lg-3">
        <div class="col-12 mb-lg-4" data-aos="fade-up" data-aos-duration="600" data-aos-delay="150">
            <div class="w-100">
                <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                        <input placeholder=" " type="text" @focus="validation.user.name.state = null" v-model="user.name">
                        <div class="invalid-feedback" :class="{'d-block' : validation.user.name.state == false}">{{validation.user.name.message}}</div>
                        <label class="full-input__after-input">
                            {{$root.translateString('name')}}
                        </label>
                    </div>
                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                        <input placeholder=" " type="email" @focus="validation.address.email.state = false" v-model="user.email">
                        <div class="invalid-feedback" :class="{'d-block' : validation.user.email.state}">{{validation.user.email.message}}</div>
                        <label class="full-input__after-input">E-mail</label>
                    </div>
                </div>
                <div class="inputs-2 pt-lg-4 mb-4 mb-md-3 mt-lg-3 mb-lg-4 font-italic">
                    <small class="mb-2 text-grey">Usa i campi qui sotto per impostare una nuova password. Lasciando i campi password vuoti, manterremo quella correntemente impostata.</small>
                </div>
                <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                        <div class="eye cursor-pointer" :style="show_password ? 'opacity:.5' : ''" @click="show_password = !show_password">
                            <img alt="icona" width="30" src="/images/area-utente/show.svg"/>
                        </div>
                        <input placeholder=" " :type="!show_password ? 'password' : 'text'" @focus="validation.user.password.state = null" v-model="user.password">
                        <div class="invalid-feedback" :class="{'d-block' : validation.user.password.state == false}">{{validation.user.password.message}}</div>
                        <label class="full-input__after-input">
                            {{$root.translateString('password')}}
                        </label>
                    </div>
                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                        <div class="eye cursor-pointer" :style="show_password_confirmation ? 'opacity:.5' : ''" @click="show_password_confirmation = !show_password_confirmation">
                            <img alt="icona" width="30" src="/images/area-utente/show.svg"/>
                        </div>
                        <input placeholder=" " :type="!show_password_confirmation ? 'password' : 'text'" @focus="validation.user.password_confirmation.state = null" v-model="user.password_confirmation">
                        <div class="invalid-feedback" :class="{'d-block' : validation.user.password_confirmation.state == false}">{{validation.user.password_confirmation.message}}</div>
                        <label class="full-input__after-input">
                            {{$root.translateString('password_confirmation')}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="pt-4 pt-lg-5">
                <div class="brand-btn mb-4 mb-xl-5">
                    <a type="submit" href="javascript:void(0)" @click="updateProfile" class="full py-2 text-center">
                        <span class="my-1">
                             {{$root.translateString('save-edits')}}
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="loader-checkout d-flex align-items-center justify-content-center" v-if="loading">
                <img width="40" src="/images/loader.svg" alt="loader"/>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['lang', 'userProp'],
    data() {
        return {
            show_password_confirmation: false,
            show_password: false,
            loading: false,
            user: {
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
            },
            validation:{
                user:{
                    name:{
                        state: null,
                        message: '',
                    },
                    email:{
                        state: null,
                        message: '',
                    },
                    password:{
                        state: null,
                        message: '',
                    },
                    password_confirmation:{
                        state: null,
                        message: '',
                    },
                }
            },
        }
    },
    mounted() {
        this.user.name = this.userProp.name;
        this.user.email = this.userProp.email;
    },
    methods: {
        updateProfile() {

            let is_invalid = false;

            Object.keys(this.validation.user).forEach((elem, key) => {
                this.validation.user[elem].message = '';
                this.validation.user[elem].state = null;
            });

            if (this.user.name == '') {
                if(this.lang == 'it') {
                    this.validation.user.name.message = 'Questo campo non può essere vuoto.';
                }else{
                    this.validation.user.name.message = 'This field cannot be empty.';
                }
                this.validation.user.name.state = false;
                is_invalid = true;
            }else{
                this.validation.user.name.state = null;
            }

            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let disposable = require('is-disposable-email');
            if (! re.test(this.user.email)) {
                if(this.lang == 'it') {
                    this.validation.user.email.message = 'Non sembra un indirizzo email valido.';
                }else{
                    this.validation.user.email.message = 'The email address is invalid.';
                }
                this.validation.user.email.state = false;
                is_invalid = true;
            } else {
                if (disposable(this.user.email)) {
                    if(this.lang == 'it') {
                        this.validation.user.email.message = 'Tipologia di servizio email non valido.';
                    }else{
                        this.validation.user.email.message = 'You email provider is invalid.';
                    }
                    this.validation.user.email.state = false;
                    is_invalid = true;
                } else {
                    this.validation.user.email.state = null;
                }
            }

            if(this.user.password != '' || this.user.password_confirmation != '' ) {

                if (this.user.password == '') {
                    if(this.lang == 'it') {
                        this.validation.user.password.message = 'Questo campo non può essere vuoto.';
                    }else{
                        this.validation.user.password.message = 'This field cannot be empty.';
                    }
                    this.validation.user.password.state = false;
                    is_invalid = true;
                }else{
                    this.validation.user.password.state = null;
                }

                if (this.user.password_confirmation != this.user.password || this.user.password_confirmation == '') {
                    if(this.lang == 'it') {
                        this.validation.user.password_confirmation.message = 'Questo campo deve coincidere con la password.';
                    }else{
                        this.validation.user.password_confirmation.message = 'Questo campo non può essere vuoto.';
                    }
                    this.validation.user.password_confirmation.state = false;
                    is_invalid = true;
                }else{
                    this.validation.user.password_confirmation.state = null;
                }

            }

            if(!is_invalid) {

                this.loading = true;

                axios.post('/api/user/profile-update', this.user).then((response) => {
                    if(response.data.success == true) {
                        this.loading = false;
                        let message = '';

                        if(this.lang == 'it') {
                            message = 'Dati profilo aggiornati correttamente.';
                        } else {
                            message = 'Your personal information have been successfully updated.';
                        }

                        this.$eventHub.$emit('notification', {
                            type: 'success',
                            message: message,
                        });
                    }

                }).catch( e =>  {
                    console.log(e);
                });

            } else {
                this.loading = false;
                let message = '';

                if(this.lang == 'it') {
                    message = 'Errore durante il salvataggio, ti preghiamo di riprovare.';
                }else{
                    message = 'An error occured while saving, please retry.';
                }

                this.$eventHub.$emit('notification', {
                    type: 'error',
                    message: message,
                    time: 10
                });

            }

        }
    },
    beforeDestroy() {
    },
    computed: {
    }
}
</script>
